"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMedia = void 0;
var useMedia_1 = require("./useMedia");
Object.defineProperty(exports, "useMedia", { enumerable: true, get: function () { return __importDefault(useMedia_1).default; } });
//# sourceMappingURL=index.js.map